export default __webpack_public_path__ + "static/media/hotel-bg.63ba0438.jpg";